import {
  LIST_REQUEST, LIST_SUCCESS, LIST_FAILURE,
  CREATE_REQUEST, CREATE_SUCCESS, CREATE_FAILURE,
  UPDATE_REQUEST, UPDATE_SUCCESS, UPDATE_FAILURE,
  DELETE_REQUEST, DELETE_SUCCESS, DELETE_FAILURE,
  TRIGGER_REQUEST, TRIGGER_SUCCESS, TRIGGER_FAILURE,
  PREVIEW_SCHEDULE_REQUEST, PREVIEW_SCHEDULE_SUCCESS, PREVIEW_SCHEDULE_FAILURE,
  CLEAR
} from '../../actions/ingestion/jobs';

const initialState = {
  // List state
  jobs: [],
  isLoading: false,
  error: null,
  
  // Create state
  isCreating: false,
  createError: null,
  createdJob: null,
  
  // Update state
  isUpdating: false,
  updateError: null,
  updatedJob: null,
  
  // Delete state
  isDeleting: false,
  deleteError: null,
  deletedJobId: null,
  
  // Trigger state
  isTriggering: false,
  triggerError: null,
  triggerResult: null,
  
  // Preview schedule state
  isLoadingSchedule: false,
  scheduleError: null,
  schedulePreview: {}
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    // List jobs
    case LIST_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null
      };
    
    case LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        jobs: action.payload.jobs || action.payload,
        error: null
      };
    
    case LIST_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    
    // Create job
    case CREATE_REQUEST:
      return {
        ...state,
        isCreating: true,
        createError: null,
        createdJob: null
      };
    
    case CREATE_SUCCESS:
      return {
        ...state,
        isCreating: false,
        createdJob: action.payload,
        createError: null,
        // Add to jobs list if it exists
        jobs: state.jobs ? [...state.jobs, action.payload] : state.jobs
      };
    
    case CREATE_FAILURE:
      return {
        ...state,
        isCreating: false,
        createError: action.payload
      };
    
    // Update job
    case UPDATE_REQUEST:
      return {
        ...state,
        isUpdating: true,
        updateError: null,
        updatedJob: null
      };
    
    case UPDATE_SUCCESS:
      return {
        ...state,
        isUpdating: false,
        updatedJob: action.payload,
        updateError: null,
        // Update in jobs list if it exists
        jobs: state.jobs ? state.jobs.map(job => 
          job.job_id === action.payload.job_id ? action.payload : job
        ) : state.jobs
      };
    
    case UPDATE_FAILURE:
      return {
        ...state,
        isUpdating: false,
        updateError: action.payload
      };
    
    // Delete job
    case DELETE_REQUEST:
      return {
        ...state,
        isDeleting: true,
        deleteError: null,
        deletedJobId: null
      };
    
    case DELETE_SUCCESS:
      return {
        ...state,
        isDeleting: false,
        deletedJobId: action.payload.jobId,
        deleteError: null,
        // Remove from jobs list if it exists
        jobs: state.jobs ? state.jobs.filter(job => 
          job.job_id !== action.payload.jobId
        ) : state.jobs
      };
    
    case DELETE_FAILURE:
      return {
        ...state,
        isDeleting: false,
        deleteError: action.payload
      };
    
    // Trigger job
    case TRIGGER_REQUEST:
      return {
        ...state,
        isTriggering: true,
        triggerError: null,
        triggerResult: null
      };
    
    case TRIGGER_SUCCESS:
      return {
        ...state,
        isTriggering: false,
        triggerResult: action.payload,
        triggerError: null
      };
    
    case TRIGGER_FAILURE:
      return {
        ...state,
        isTriggering: false,
        triggerError: action.payload
      };
    
    // Preview schedule
    case PREVIEW_SCHEDULE_REQUEST:
      return {
        ...state,
        isLoadingSchedule: true,
        scheduleError: null
      };
    
    case PREVIEW_SCHEDULE_SUCCESS:
      return {
        ...state,
        isLoadingSchedule: false,
        scheduleError: null,
        schedulePreview: {
          ...state.schedulePreview,
          [action.payload.jobId]: action.payload.next_runs
        }
      };
    
    case PREVIEW_SCHEDULE_FAILURE:
      return {
        ...state,
        isLoadingSchedule: false,
        scheduleError: action.payload
      };
    
    // Clear state
    case CLEAR:
      return initialState;
    
    default:
      return state;
  }
};
